import React from 'react';
import { Progress } from '@/components/ui/progress';

interface UploadProgressProps {
  progress: number;
  status: string;
}

export const UploadProgress: React.FC<UploadProgressProps> = ({
  progress,
  status,
}) => {
  return (
    <div className="space-y-2">
      <Progress value={progress} className="w-full" />
      <p className="text-sm text-muted-foreground">{status}</p>
    </div>
  );
};

